<template>
  <div class="wizard-item-slide disable-select" :class="{active:tab.active}" :id="'wizardTab'+tab.tabIndex">
    <a href="javascript:void(0)"
           role="tab"
           :tabindex="tab.checked ? 0 : ''"
           :id="`step-${tab.tabId}`"
           :aria-controls="tab.tabId"
           :aria-disabled="tab.active"
           :aria-selected="tab.active"
           :class="{disabled: !tab.checked, checked: tab.checked,square_shape:isStepSquare, tab_shape:isTabShape, 'disable-select':true}"
           :style="[tab.checked ? stepCheckedStyle : {}]">
        <slot name="number">
          <span class="stepNumber"
                :class="{active:tab.active, has_error:tab.validationError}"
                :style="tab.active ? stepTitleStyle : {}">
                {{tab.stepNumber}}
          </span>
        </slot>
        <slot name="title">
          <span class="stepTitle"
                :class="{active:tab.active, has_error:tab.validationError}"
                :style="tab.active ? stepTitleStyle : {}">
                {{tab.title}}
          </span>
					<span class="stepIcon"
						v-if="tab.badgeCount > 0"
								:class="{active:tab.active, has_error:tab.validationError}"
								:style="tab.active ? stepTitleStyle : {}">
								<font-awesome-icon icon="exclamation-triangle" />
					</span>
          <slot name="stepAfterImage" >
          	<span v-html="getStepImage" class="stepAfterImage"></span>
          	<span v-html="getStepImageSpacer" :id="'stepAfterImage'+tab.tabIndex" class="stepAfterImageSpacer"></span>
          </slot>
        </slot>
    </a>
  </div>
</template>
<script>
  export default {
    name: 'wizard-step',
    props: {
      tab: {
        type: Object,
        default: () => {

        }
      },
      transition: {
        type: String,
        default: ''
      },
      index: {
        type: Number,
        default: 0
      },
      activeTabIndex: {
        type: Number,
        default: 0
      }
    },
    computed: {
      iconActiveStyle () {
        return {
          backgroundColor: this.tab.color
        }
      },
      stepCheckedStyle () {
        return {
          borderColor: this.tab.color
        }
      },
      getStepImage() {
      	let img = null;
      		if (this.tab)  {
      			if (this.activeTabIndex == this.tab.tabIndex) {
      						return '<img src="/img/nav/wizard-active-inactive-bg.png"/>';
      			}
  					if (this.activeTabIndex == this.tab.tabIndex + 1) {
  						return '<img src="/img/nav/wizard-inactive-active-bg.png"/>';
  					} else {
  						return '<img src="/img/nav/wizard-inactive-inactive-bg.png"/>';
  					}
      		}
      	return img;
      },
      getStepImageSpacer() {
  				return '<img src="/img/lcr-quick-nav/blank.png" style="width:25px; height:5px"/>';
      },
      errorStyle () {
        return {
          borderColor: this.tab.errorColor,
          backgroundColor: this.tab.errorColor
        }
      },
      stepTitleStyle () {
        let isError = this.tab.validationError
        return {
          color: isError ? this.tab.errorColor : this.tab.color
        }
      },
      isStepSquare () {
        return this.tab.shape === 'square'
      },
      isTabShape () {
        return this.tab.shape === 'tab'
      }
    }
  }
</script>
<style>
</style>
